import { inject, Injectable } from '@angular/core';
import { Product } from '@services/product.model';
import { ProductsService } from '@services/products.service';
import { Store } from '@services/store';
import { defer, firstValueFrom, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductsStore extends Store<Product[]> {
  private readonly productsService = inject(ProductsService);

  protected getDataSource(key: string): Observable<Product[]> {
    return this.productsService.getList(key);
  }

  getAll(): Observable<Record<string, Product[]>> {
    return defer(async () => {
      const keys = await this.keys();
      return keys.length > 0 ? await this.getMany(keys) : await this.loadAll();
    });
  }

  private async loadAll() {
    const products = await firstValueFrom(this.productsService.getAll(), { defaultValue: {} as Record<string, Product[]> });

    for (const key of Object.keys(products)) {
      await this.set(key, products[key]);
    }

    return products;
  }
}
